/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2024, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { RadioButton, RadioButtonGroup } from 'carbon-components-react';

import { messages as ConfigOptionMessages } from '../../../discovery/components/search-detail-config/messages';
import {
  CONFIDENCE_THRESHOLD_VALUE,
  RESPONSE_LENGTH_VALUE
} from '../../../discovery/util/constants';

export interface RadioSliderSelectorProps {
  readOnly: boolean;
  labelText: any;
  radioSliderName: string;
  labels: Array<string>;
  selectedIndex: number;
  selectedValue: string;
  onSelectionChange: (string) => void;
}

export const RadioSliderSelector = ({
  readOnly,
  labelText,
  radioSliderName,
  labels,
  selectedValue,
  onSelectionChange
}: RadioSliderSelectorProps) => {
  const getValueFromLabel = (label: string) => {
    switch (label) {
      case ConfigOptionMessages.lowest.defaultMessage:
        return CONFIDENCE_THRESHOLD_VALUE.RARELY;
      case ConfigOptionMessages.low.defaultMessage:
        return CONFIDENCE_THRESHOLD_VALUE.LESS_OFTEN;
      case ConfigOptionMessages.high.defaultMessage:
        return CONFIDENCE_THRESHOLD_VALUE.MORE_OFTEN;
      case ConfigOptionMessages.highest.defaultMessage:
        return CONFIDENCE_THRESHOLD_VALUE.MOST_OFTEN;
      case ConfigOptionMessages.conversationalSearchResponseConcise
        .defaultMessage:
        return RESPONSE_LENGTH_VALUE.CONCISE;
      case ConfigOptionMessages.conversationalSearchResponseModerate
        .defaultMessage:
        return RESPONSE_LENGTH_VALUE.MODERATE;
      case ConfigOptionMessages.conversationalSearchResponseVerbose
        .defaultMessage:
        return RESPONSE_LENGTH_VALUE.VERBOSE;
    }
  };

  return (
    <div className="RadioSliderSelector">
      <RadioButtonGroup
        disabled={readOnly}
        legendText={labelText}
        valueSelected={selectedValue}
        name={radioSliderName}
        onChange={name => onSelectionChange(name)}>
        {labels.map(label => {
          return (
            <RadioButton
              disabled={readOnly}
              labelText={label}
              key={`${radioSliderName}-${label}`}
              id={`${radioSliderName}-${label}`}
              value={getValueFromLabel(label)}></RadioButton>
          );
        })}
      </RadioButtonGroup>
    </div>
  );
};
